"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChapterHighlightOptimisticResponse = exports.updateChapterHighlights = exports.ADD_CHAPTER_HIGHLIGHT = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
exports.ADD_CHAPTER_HIGHLIGHT = (0, client_1.gql) `
  ${fragments_1.HIGHLIGHT_FIELDS}
  mutation AddChapterHighlight(
    $input: [AddChapterHighlightInput!]!
    $marksheetId: Int
  ) {
    restricted {
      addChapterHighlight(input: $input, marksheetId: $marksheetId) {
        id
        chapterId
        userId
        highlights {
          ...HighlightFields
        }
      }
    }
  }
`;
const updateChapterHighlights = (cache, result, options) => {
    const { addChapterHighlight } = result?.data?.restricted ?? {};
    const { variables } = options || {};
    if (!variables || !addChapterHighlight) {
        return;
    }
    try {
        for (const { chapterId, highlights } of addChapterHighlight) {
            cache.writeFragment({
                id: cache.identify({
                    id: chapterId,
                    __typename: 'Chapter',
                }),
                data: {
                    highlights,
                },
                fragment: fragments_1.CHAPTER_WITH_HIGHLIGHT_FIELDS,
            });
        }
    }
    catch (error) {
        console.error(error);
    }
};
exports.updateChapterHighlights = updateChapterHighlights;
const getChapterHighlightOptimisticResponse = (userId, highlights, chapterId) => {
    const date = new Date().getTime();
    return {
        restricted: {
            addChapterHighlight: [
                {
                    chapterId,
                    id: date,
                    userId,
                    createdAt: date,
                    updatedAt: date,
                    deletedAt: date,
                    highlights: highlights.map((highlight) => ({
                        __typename: 'HighlightNode',
                        tag: '',
                        color: '',
                        ...highlight,
                        part: highlight.part || '',
                    })),
                    __typename: 'ChapterHighlight',
                },
            ],
        },
    };
};
exports.getChapterHighlightOptimisticResponse = getChapterHighlightOptimisticResponse;
